module.exports = __webpack_public_path__ + "img/weixin.bf5f42e8.jpeg";